// A tool result kept small: the platform parses every JSON body at 64 KB before the app's routes,
// and the chat sends its turns back each time, so each result stays under ~3 KB (CLAUDE.md "In
// this app"). The list goes shorter, never the counts.

/** Under this many characters of JSON: what a tool answers. */
export const TOOL_RESULT_MAX = 2800;

/**
 * `result` with its list `key` cut from the end until the JSON fits; `total` is how many matched,
 * said as `listed` of it when the list is shorter.
 */
export function fitList<T extends Record<string, unknown>>(result: T, key: keyof T & string, total: number): T {
  let list = result[key] as unknown[];
  let out: T = result;
  while (JSON.stringify(out).length > TOOL_RESULT_MAX && list.length) {
    list = list.slice(0, Math.max(0, Math.floor(list.length * 0.75)));
    out = { ...result, [key]: list };
  }
  return list.length < total ? { ...out, listed: list.length, of: total } : out;
}
